<div class="col px-lg-5 px-2">
	<app-nav-prestation></app-nav-prestation>

	<div *ngIf="prestation" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ prestation.typePrestation }}</span
					>
				</div>

				<div class="">
					<a
						*ngIf="isDeletable"
						(click)="openConfirmDeleteModal(deletePrestation)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<app-prestation-form
				*ngIf="!isFormReadOnly"
				[prestation]="prestation"
				[isAddForm]="false"
				[form]="prestationDetailForm"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			>
			</app-prestation-form>
            <div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col-6">
						<label
							for="inputPrestationStatut"
							class="form-label theme-main-color fw-bold"
							>Statut</label
						>
						<span class="form-control-plaintext">{{
							PrestationStatutStringEnum[prestation.statut]
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="dateDebut" class="form-label fw-bold"
							>Date de réception de la demande</label
						>
						<span class="form-control-plaintext">{{
							prestation.dateDebut | date: 'dd/MM/yyyy'
						}}</span>
					</div>
					<div class="col-12 col-lg">
						<label for="dateLimite" class="form-label fw-bold"
							>Date de l'AR</label
						>
						<span class="form-control-plaintext">{{
							prestation.dateAr | date: 'dd/MM/yyyy'
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="dateFin" class="form-label fw-bold"
							>Date de fin(envoi d'une fiche de synthèse)</label
						>
						<span class="form-control-plaintext">{{
							prestation.dateFin | date: 'dd/MM/yyyy'
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg-6">
						<label for="prescripteur" class="form-label fw-bold"
							>Prescripteur</label
						>
						<span class="form-control-plaintext">{{
							prestation.prescripteur?.nomStructure
						}}</span>
					</div>
					<div class="col-12 col-lg-6">
						<label for="statutBeneficiaire" class="form-label fw-bold"
							>Statut du bénéficiaire</label
						>
						<span class="form-control-plaintext">{{
							StatutBeneficiaireStringEnum[prestation.statutBeneficiaire]
						}}</span>
					</div>
				</div>

			</div>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm(true)"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!prestationDetailForm.valid || isValidateButtonClicked.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<div *ngIf="prestation" class="my-4">
		<div class="row my-5">
			<span class="theme-main-color fw-bold fs-5"
				>Activités</span
			>
		</div>
		<div class="row mb-5 d-flex justify-content-start">
			<button class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
				(click)="openModalActivitePrestationAjout()"
			>
				<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
			</button>
		</div>
		<div class="my-2">
			<!-- <div
				*ngFor="
					let suivi of suiviPrestationList
						| sortBySuiviPrestationDate : sortOrder
						| paginate : { itemsPerPage: 5, currentPage: currentPage }
						| orderBy : 'suivi.dateEntretien' : sortOrder
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailFormation(suivi)"
			> -->

			<div
			*ngFor="
					let activite of activitePrestationList
						| paginate : { itemsPerPage: 5, currentPage: currentPageActivite }
						| orderBy : 'activite.chargeTravail' : sortOrderActivite
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailActivite(activite)"
			>
				<div class="col-lg-2 col-10">
					<span class="align-middle">
						{{ activite.modaliteReunion?.name }}
					</span>
				</div>
				<div class="col-lg-5 col" *ngIf="true">
					<span class="align-middle">{{
						activite.tache?.name
					}}</span>
				</div>
				<div class="col-lg-2 col" *ngIf="true">
					<span class="align-middle">Charge de travail : {{
						activite.chargeTravail
					}}H</span>
				</div>
				<div class="col-lg-3 col" *ngIf="true">
					<span class="align-middle">Intervenant : {{
						 activite.intervenant?.firstName + ' ' + activite.intervenant?.lastName
					}}</span>
					<i
						class="bi bi-caret-right-fill mb-1 align-middle"
						aria-hidden="true"
					></i>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls
					class="d-flex justify-content-center"
					(pageChange)="currentPage = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div>

	<ng-template #deletePrestation>
		<div class="modal-header text-center">
			<h4>Suppression</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			<a class="btn theme-red-button ms-3" (click)="delete(prestation)"
				>Supprimer</a
			>
		</div>
	</ng-template>
</div>
